<template>
  <Modal
    :modal="reminderStructureModalRef"
    :steps="[
      {
        id: 'reminder-structure',
        component: ReminderStructureModalContent,
      },
    ]"
    :onExit="onClose"
  />
</template>

<script lang="ts" setup>
import ReminderStructureModalContent from '@/features/admin/reminders/components/reminder-structure-modal/reminder-structure-modal-content/reminder-structure-modal-content.vue'
import Modal from '@/features/ui/components/modal/modal.vue'
import { selectGetReminderStructureModal } from '@/features/ui/store/modal/modal.selectors'
import modalsStore from '@/features/ui/store/modal/modal.store'

const reminderStructureModalRef = selectGetReminderStructureModal(modalsStore)

function onClose() {
  console.log('onClose')
  modalsStore.updateModalAttachedData('admin-reminder-structure', { reminderId: null })
}
</script>
